import { getShellApiInstance } from './shell-api-instance'
import type { ShellApi } from '../../core/models'

type Namespaces = ShellApi['namespaces']

export const getShellNamespaces = (): Namespaces => getShellApiInstance()?.namespaces
